import { basicMsg, msg as swalMsg } from './swal_msg';
import { axiosRequest } from "../helpers/requestHelper";

import { paypalOrder } from './payment/paypal_payment';
import { openPayCharge } from './payment/openpay_payment';
import { mercadoPagoReference } from './payment/mercadopago_payment';

import { SUPPORT_NUMBER_VIEW } from '../constants/constants';

// subir documento CIF a drive
const uploadCIFDocument = async(file) => {
    try {
        const data = new FormData();
        data.append('file', file);
        const req = await axiosRequest('file/upload-cif', data, 'POST');
        if (req.status) {
            const { fileId } = req.resp;
            return fileId;
        } else {
            if (req.msg === 'not-uploaded')
                basicMsg('Documento CIF no guardado');
            else if (req.msg === 'no-files')
                basicMsg('No se envió su documento CIF');
            else if (req.msg === 'server-err')
                basicMsg('Incidente al querer guardar documento CIF');
            else
                swalMsg('error', 'Checkout',
                'No se pudo guardar su documento CIF');
        }
        return '';
    } catch (err) {
        basicMsg('Error al guardar documento CIF');
        return '';
    };
};

// elabora un hash como referencia de la orden
export const createHash = () => {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    let result = '';
    for (let i=0; i<99; i++) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    };
    return result;
};

export const getFullOrder = async (model, payment_method) => {
    const {
        addressValues, billingValues, summary,
        shipping, cart, couponData
    } = model;
    // datos de facturación
    const {
        req_invoice, cif, filename, billing_tel, billing_postalcode,
        billing_colony, billing_city, billing_state, ...billing
    } = billingValues;

    // referencia
    const nefro_reference = createHash();

    let data = null;
    if (req_invoice) { // necesita factura
        const cif_file = filename ? await uploadCIFDocument(filename) : (cif ? cif : '');
        data = {
            ...billing,
            cif: cif_file,
            tel: billing_tel,
            postalcode: billing_postalcode,
            colony: billing_colony,
            city: billing_city,
            state: billing_state
        };
    }

    const {
        residence_type, residence_type_select,
        ...address
    } = addressValues;

    // cupón
    const coupon = (couponData && couponData.name !== '') ? { ...couponData } : null;
    // token sesión usuario
    const user_token = localStorage.getItem('token') || '';
    // token carrito
    const token = localStorage.getItem('cart-token') || '';
    
    return {
        user_token, token,
        summary, // resumen de carrito
        coupon,
        address: {
            ...address,
            residence_type: residence_type_select === 'Otro' ?
                residence_type : residence_type_select
        },
        billing: { req_invoice, data },
        products: [...cart],
        shipping: {
            ...shipping,
            method_id: shipping._id,
            status: 'standby'
        },
        payment: {
            method: payment_method,
            nefro_reference,
            status: 'registered'
        }
    };
};

// ¿requiere factura? / procesar información
export const processOrder = async(OrderModel, payment_method) => {
    try {
        if (payment_method === 'PayPal')
            return await paypalOrder(OrderModel);
        else if (payment_method === 'MercadoPago')
            return await mercadoPagoReference(OrderModel);
        else if (payment_method === 'OpenPay')
            return await openPayCharge(OrderModel);
        // else if (payment_method === 'EvoPayments')
        //     return await evoPaymentsSession(OrderModel, nefro_reference);
        else {
            basicMsg('No se reconoce el método de pago');
            return { status: false };
        }
    } catch (err) {
        swalMsg('error', 'Checkout',
        `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`);
        return { status: false };
    };
};
